(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rating-stars"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cuppy-loox-slider')) {
  customElements.define('cuppy-loox-slider', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      this._init = setTimeout(() => this.init(), 0);
    }
    disconnectedCallback() {
      clearTimeout(this._init); clearTimeout(this._timer);
      this._controller?.abort(); this._controller = null;
      this._observer?.disconnect();
    }
    init() {
      let pool;
      try { pool = JSON.parse(this.querySelector('[data-review-pool]').textContent); } catch (_) { return; }
      if (String(pool.product_id) !== this.dataset.productId) return;
      this._reviews = pool.reviews.filter(r => r.rating === 5 && r.text?.trim() && /^https:\/\/images\.loox\.io\//.test(r.image || ''));
      if (!this._reviews.length) return;
      // Shuffle the real photo reviews once per page load.
      for (let i = this._reviews.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [this._reviews[i], this._reviews[j]] = [this._reviews[j], this._reviews[i]];
      }
      this._index = 0; this._focus = false; this._inView = true;
      this._autoplay = this.dataset.autoplay !== 'false';
      this._interval = Math.min(15000, Math.max(2000, Number(this.dataset.interval) || 5000));
      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      const options = { signal: this._controller.signal };
      this._viewport = this.querySelector('.cuppy-review-slider__viewport');
      this.addEventListener('focusin', () => { this._focus = true; this._viewport.setAttribute('aria-live', 'polite'); this.schedule(); }, options);
      this.addEventListener('focusout', e => { this._focus = this.contains(e.relatedTarget); this._viewport.setAttribute('aria-live', this._focus ? 'polite' : 'off'); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this._motion.addEventListener('change', () => this.schedule(), options);
      this._observer = new IntersectionObserver(entries => { this._inView = entries[0].isIntersecting; this.schedule(); });
      this._observer.observe(this);
      this.querySelector('.cuppy-review-slider__card').hidden = false;
      this.render(); this.schedule();
    }
    next() { this._index = (this._index + 1) % this._reviews.length; this.render(); this.schedule(); }
    schedule() {
      clearTimeout(this._timer);
      if (this._reviews?.length > 1 && this._autoplay && !this._focus && this._inView && !document.hidden && !this._motion.matches) {
        this._timer = setTimeout(() => this.next(), this._interval);
      }
    }
    render() {
      const r = this._reviews[this._index];
      const slide = document.createElement('div'); slide.className = 'cuppy-review-slider__slide';
      slide.setAttribute('role', 'group'); slide.setAttribute('aria-roledescription', 'שקופית');
      slide.setAttribute('aria-label', `${this._index + 1} מתוך ${this._reviews.length}`);
      const image = document.createElement('img'); image.className = 'cuppy-review-slider__image';
      image.src = r.image; image.alt = 'תמונת הביקורת של ' + r.author; image.width = 64; image.height = 72; image.decoding = 'async';
      const body = document.createElement('div'); body.className = 'cuppy-review-slider__body';
      const heading = document.createElement('div'); heading.className = 'cuppy-review-slider__heading';
      const author = document.createElement('span'); author.className = 'cuppy-review-slider__author'; author.textContent = r.author;
      const stars = document.createElement('span'); stars.className = 'cuppy-review-slider__stars'; stars.textContent = '★★★★★'; stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', '5 מתוך 5 כוכבים');
      const quote = document.createElement('blockquote'); quote.className = 'cuppy-review-slider__text'; quote.dir = 'auto'; quote.textContent = r.text; quote.title = r.text;
      heading.append(author, stars); body.append(heading, quote); slide.append(image, body);
      this._viewport.replaceChildren(slide);
      this.dataset.reviewId = r.id;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
